<template>
  <div>
    <!--导航栏 start-->
    <van-nav-bar
        left-text="返回"
        fixed
        title="桌台管理"
        left-arrow
        right-text="新增桌台"
        @click-left="onClickLeft"
        @click-right="onClickRight"

    >
      <!--通过插槽自定义导航栏右侧的内容 end-->
    </van-nav-bar>
    <!--导航栏 end-->
    <!-- 列表 start-->
    <van-grid :column-num="2" :border="false" style="margin-top: 1rem">
      <van-grid-item  text="桌台名称" />
      <van-grid-item  text="操作" />
    </van-grid>
    <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="init"
    >
      <van-cell v-for="item in list" :key="item.id" @click.prevent="seatUpdate(item.id)">
        <van-grid :column-num="2" :border="false">
          <van-grid-item :text="item.name" />
          <van-grid-item>
            <van-button @click.stop="seatDel(item.id)" style="width: 1.5rem;height: 0.6rem;position:relative; left: 0.2rem;" size="small"  type="danger">删除</van-button>
          </van-grid-item>
        </van-grid>
      </van-cell>
    </van-list>
    <!-- 列表 end-->
  </div>
</template>

<script>
import Vue from 'vue';
import {List, Grid, GridItem,Dialog, Notify} from 'vant';

Vue.use(Grid);
Vue.use(GridItem);
Vue.use(List);

export default {
  name: "SeatList",
  data () {
    return {
      list: [],
      page:1,
      limit:10,
      loading: false,
      finished: false,
    }
  },
  methods: {
    // 返回上一级
    onClickLeft() {
      // 返回商户信息
      this.$router.push('/CodeOrder');
    },
    onClickRight(){
      this.$router.push('/SeatAdd')
    },
    init() {
      var that = this;
      // var salesmanInfo = VueCookie.get("salesmanInfo");
      this.$http.post('/wechat/api.store_class/seatList', {
        page: that.page,
        limit:that.limit
      }).then(response => {
        console.log(response.data.data)
        // 加载状态结束
        that.loading = false;
        that.list = that.list.concat(response.data.data)
        // 页码
        that.page++;
        if (response.data.data.length < that.limit)
        {
          that.finished = true;
        }
      });
    },
    seatUpdate(id) {
      this.$router.push({path:"/SeatUpdate", query:{id:id}})
    },
    seatDel(id) {
      Dialog.confirm({
        title: '删除桌台',
        message: '确定删除该桌台吗?',
      })  .then(() => {
        this.$http.get('/wechat/api.store_class/Seatdel', {params:
              {
                id:id,
              }
        }).then(response => {
          if (response && response.body.code== 200) {
            Notify({type: 'success', message: response.body.msg});
            setTimeout(()=>{
              this.$router.go(0)
            },200)

          }else {
            Notify({type: 'danger',message:response.body.msg});
          }
        })
      })

    }
  }
}
</script>

<style scoped>

</style>
